





import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import ModalsView from "@/app/views/modals/modals.component.vue";
import Loader from "@/resources/mixins/loader/loader";
import LoadApp from "@/resources/mixins/loadApp/loadApp";
@Component({
  components: {
    ModalsView,
  },
})
export default class HawkingsView extends mixins(LoadApp, Loader) {
  constructor() {
    super();
  }
  created(): void {
    this.$store.dispatch("SystemStore/setEducationToolModalAction", true);
  }
}
